import { render } from "./ItemReceive_edit.vue?vue&type=template&id=6b166225"
import script from "./ItemReceive_edit.vue?vue&type=script&lang=js"
export * from "./ItemReceive_edit.vue?vue&type=script&lang=js"

import "./ItemReceive_edit.vue?vue&type=style&index=0&id=6b166225&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__